import React, {useState, useEffect} from 'react'
import ResponseMsg2 from '../../general/ResponseMsg2'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck, FaPlus } from 'react-icons/fa';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';


const CreateTimeTable = ({setLoading}) => {
        const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [showAddSection, setShowAddSection] = useState(false);
   const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
     const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [availableSections, setAvailableSections] = useState([]);
const [periods, setPeriods] = useState([
  { subjectId: '' }
]);
const [selectedDay, setSelectedDay] = useState('');

  const [timeTable, setTimeTable] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [selectedTTable, setSelectedTTable] = useState('');
const [showDelete, setShowDelete]  = useState(false);
const [isEditMode, setIsEditMode] = useState(false);


const handleToggle = () => {
  setShowAddSection((prev) => !prev);
  if (showAddSection) {
    setPeriods([{ subjectId: '' }]);
    setSelectedClassId('');
    setSelectedSection('');
    setSelectedDay('');
    setIsEditMode(false);
    setSelectedTTable(null);
  }
};


const handleEdit = async (tt) => {
  setSelectedClassId(tt.class_id);
  setSelectedSection(tt.section);
  setSelectedDay(tt.day);

  const existingPeriods = Object.keys(tt.periods).map((label) => {
    const assignId = tt.periods[label]?.id || '';
    return { subjectId: assignId };
  });
  setPeriods(existingPeriods);

  setIsEditMode(true);
  setSelectedTTable(tt);
  setShowAddSection(true);

  fetchSubjects(tt.class_id, tt.section);
};


     const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                           setClasses(data);
                           setLoading(false);
                                                     console.log(data);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }


const fetchSubjects = async (selectedClassId, selectedSection) => {
  if (!selectedClassId || !selectedSection) {
    setResponse2({ message: 'Please select class and section before searching', status: 'error' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${selectedClassId}&section=${selectedSection}`);

    if (res.ok) {
      const data = await res.json();

      if(data.length > 0){
        console.log(data);
      setSubjects(data);

      setResponse2({ message: 'Assigned Subjects Fetched Successfully', status: 'success' });
      }
      else {
        // setAssignments([{ subject_id: '', teacher_id: '' }]);
        setSubjects([]);
        setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch assigned subjects error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};



            const fetchTimeTable = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-time-table');
        
                        if (response.ok) {
                            const data = await response.json();
                            console.log(data);
                            setTimeTable(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch class');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }

     useEffect(() => {
         fetchClasses();
         fetchTimeTable();
     }, []);
      

useEffect(() => {
  if (selectedClassId) {
    const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));

    if (selectedClass && selectedClass.sections) {
      const sectionArray = selectedClass.sections
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s !== '');

      setAvailableSections(sectionArray);

      // Only reset section if NOT in edit mode
      if (!isEditMode) {
        setSelectedSection('');
      }
    } else {
      setAvailableSections([]);
      if (!isEditMode) {
        setSelectedSection('');
      }
    }
  }
}, [selectedClassId, classes, isEditMode]);


const periodLabels = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const addPeriod = () => {
  if (periods.length < periodLabels.length) {
    setPeriods([...periods, { subjectId: '' }]);
  }
};


const removePeriod = (index) => {
  const updatedPeriods = [...periods];
  updatedPeriods.splice(index, 1);
  setPeriods(updatedPeriods);
};


const handleSubjectChange = (index, subjectId) => {
  const updatedPeriods = [...periods];
updatedPeriods[index].subjectId = subjectId;
  setPeriods(updatedPeriods);
};


const handleSubmit = async (e) => {
  e.preventDefault();

if (!selectedClassId || !selectedSection || !selectedDay) {
  setResponse2({ message: 'Please select class, section, and day.', status: 'error' });
  return;
}


console.log(periods);

const payload = {
  class_id: selectedClassId,
  section: selectedSection,
  day: selectedDay,
  period: periods.map((p, index) => ({
    period: periodLabels[index],
    assignId: p.subjectId
  }))
};


  try {
    setLoading(true);
const url = isEditMode
  ? `https://api.kcian.in/update-time-table/${selectedTTable.id}`
  : 'https://api.kcian.in/create-timetable';

const method = isEditMode ? 'PUT' : 'POST';

const res = await fetch(url, {
  method,  
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload)
});

    const result = await res.json();

if (res.ok) {
  setResponse2({
    message: isEditMode
      ? 'Time Table Updated successfully!'
      : 'Time Table Created successfully!',
    status: 'success'
  });
      fetchTimeTable();
      handleToggle();
    } else {
                setResponse2({ message: result.message || 'Something Went Wrong. Please try again.', status: 'error' });
              }
  } catch (err) {
    console.log(err);
  } finally {
setTimeout(() => {
          setResponse2('');
        }, 3000); 
            setLoading(false);
  }
};


  const filteredTable = timeTable.filter(tt => {
  const term = searchTerm.toLowerCase();
  return (
    tt.day.toLowerCase().includes(term) ||
        tt.section.toLowerCase().includes(term) ||
        tt.class_name.toLowerCase().includes(term)
  );
});

// Get max number of periods used in timetable data
const maxPeriodsUsed = timeTable.reduce((max, tt) => {
  const periodsCount = Object.keys(tt.periods || {}).length;
  return periodsCount > max ? periodsCount : max;
}, 0);
const displayedPeriodLabels = periodLabels.slice(0, maxPeriodsUsed);


      const handleShowDelete = (feeS) => {
    setSelectedTTable(feeS);
    setShowDelete(true);
  }


                  const handleDelete = async (tId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-time-table/${tId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setTimeTable((prevData) => prevData.filter((product) => product.id !== tId));
        setShowDelete(false);
        setResponse2({ message: 'Time Table Deleted Successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };



  return (
    <>
                  <section className="py-4">
        <div className="px-4">
<HeadingArea message1="Time Table" message2={`${isEditMode ? 'Update' : 'Create'} Time Table`} />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}



          {!showAddSection ? (
            <div className='mt-2'>
<div className='profile-card'>
              <button className='profile-btn2' onClick={handleToggle}>
                <FaPlus /> Add
              </button>

  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">Time Table List</span>


                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Class Name, Subject, Day'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>S No</th>
    <th>Class</th>
    <th>Day</th>
{displayedPeriodLabels.map(label => (
      <th key={label}>{label} Period</th>
    ))}
        <th className='rounded-end-4'>Activity</th>
</thead>


{filteredTable.map((tt, index) => (
  <tr className='account-tr'>
    <td>{index+1}</td>
    <td>{tt.class_name} ({tt.section})</td>
    <td>{tt.day}</td>
{displayedPeriodLabels.map((label) => {
  const subject = tt.periods[label];
  return (
    <td key={label}>
      {subject
        ? `${subject.sub_name}(${subject.sub_code}) (${subject.sub_type == 'Theory' ? 'T' : 'P'}) `
        : "--"}
    </td>
  );
})}

    <td><MdOutlineEdit className='account-icon1' title='Edit' onClick={() => handleEdit(tt)} /> &nbsp;&nbsp;<RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(tt)} /></td>
  </tr>
))}

</table>
</div>
{/* table ends */}

</div>
</div>
 ): (
            <div className='mt-2'>

          <div className="profile-card">
            <p className="profile-heading">{isEditMode ? 'Update Time Table' : 'Create New'}</p>

<form className='mt-4 row' onSubmit={handleSubmit}>
                  {/* Select Class */}

                  <div className="mb-4 col-md-6">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4 col-md-6">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  value={selectedSection}
  onChange={(e) => setSelectedSection(e.target.value)}
  required
  disabled={availableSections.length === 0}
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>

                    </div>
                  </div>

<div className='col-12 mb-4 text-end'>
<button className='profile-btn2' onClick={() => fetchSubjects(selectedClassId, selectedSection)}>Fetch Subjects</button></div>

{/* Select Day */}
<div className="mb-4">
  <div className='profile-input-area'>
    <label className="profile-badge">Select Day*</label>
    <select
      className="profile-input"
      value={selectedDay}
      onChange={(e) => setSelectedDay(e.target.value)}
      required
      disabled={availableSections.length === 0}
    >
      <option value="">-- Select Day --</option>
      {daysOfWeek.map((day, idx) => (
        <option key={idx} value={day}>
          {day}
        </option>
      ))}
    </select>
  </div>
</div>


                  {/* Periods Section */}
{periods.map((period, index) => (
  <div className="mb-3 d-flex" key={index}>
    <div className="profile-input-area w-100">
      <label className="profile-badge">Period {periodLabels[index]}</label>
      <select
        className="profile-input"
        value={period.subjectId}
        onChange={(e) => handleSubjectChange(index, e.target.value)}
        required
      >
        <option value="">-- Select Subject --</option>
        {subjects.map((subj) => (
          <option key={subj.id} value={subj.id}>
            {subj.sub_name}({subj.sub_code}) ({subj.sub_type}) --- {subj.teacher_name}({subj.teacher_user_id})
          </option>
        ))}
      </select>
    </div>
 {periods.length > 1 && (
<button
          type="button"
          onClick={() => removePeriod(index)}
                    className="ms-2 border-0 bg-transparent cursor-pointer"
        >
                        <AiOutlineMinusCircle size={26} color='red' />
        </button>
      )}  </div>
))}


<div className="text-end mb-3">
  <button
    type="button"
                    className="border-0 bg-transparent cursor-pointer"
    onClick={addPeriod}
    disabled={periods.length >= periodLabels.length}
  >
                    <AiOutlinePlusCircle size={30} />
  </button>
</div>


                  <div className="text-center">
                                      <button onClick={handleToggle} type='button' className='profile-btn2'>
                    Go Back
                  </button>

                    <button type="submit" className="ms-2 profile-btn">
                      <FaCheck /> {isEditMode ? 'Update' : 'Save'}
                    </button>
                  </div>
                </form>

</div>
</div>
 )}


</div>
</section>


                {showDelete && (() =>   {
               return (
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Time Table!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th>Class</th>
    <th>Day</th>
{displayedPeriodLabels.map(label => (
      <th key={label}>{label} Period</th>
    ))}
</thead>


  <tr className='account-tr'>
    <td>{selectedTTable.class_name} ({selectedTTable.section})</td>
    <td>{selectedTTable.day}</td>
{displayedPeriodLabels.map((label) => {
  const subject = selectedTTable.periods[label];
  return (
    <td key={label}>
      {subject
        ? `${subject.sub_name}(${subject.sub_code}) (${subject.sub_type == 'Theory' ? 'T' : 'P'})`
        : "--"}
    </td>
  );
})}

  </tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Time Table will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedTTable.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
);
})()}

    </>
  )
}

export default CreateTimeTable
